import React from 'react';
import { useChatUi } from '../ChatContext';

const ICONS = {
  truck: ['M1 3h15v13H1z', 'M16 8h4l3 3v5h-7V8z', 'M5.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M18.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z'],
  code: ['M16 18l6-6-6-6', 'M8 6l-6 6 6 6'],
  alert: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 8v4', 'M12 16h.01'],
  settings: ['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z'],
  zap: ['M13 2L3 14h9l-1 8 10-12h-9l1-8z'],
  lightbulb: ['M9 18h6', 'M10 22h4', 'M15.1 14c.2-1 .7-1.7 1.4-2.5A4.7 4.7 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.4 2.5'],
  disc: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
};

function SuggestionIcon({ name }) {
  const paths = ICONS[name] || ICONS.lightbulb;
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths.map((d) => <path key={d} d={d} />)}
    </svg>
  );
}

/** Follow-up suggestion chips (the current Suggestion model). */
export default function FollowUps({ items, prompt, onSend, onAppend, disabled }) {
  const { t } = useChatUi();
  if (!items || !items.length) return null;
  return (
    <div className="suggestions-container cv-followups">
      <div className="suggestions-label cv-section-label">{prompt || t('Quick suggestions')}</div>
      <div className="suggestions-buttons cv-followups__list">
        {items.map((s, i) => (
          <button
            key={`${s.value}-${i}`}
            type="button"
            className="suggestion-btn cv-followup"
            disabled={disabled}
            title={s.value}
            onClick={() => {
              if (s.action === 'append_to_input') onAppend(s.value);
              else onSend(s.value, s);  // set_vehicle chips carry model / year / question
            }}
          >
            <SuggestionIcon name={s.icon} />
            <span>{s.value || s.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
